const gradients = {
    primary: 'linear-gradient(135deg, #00CDFF 0%, #0E91FD 100%)',
    secondary: 'linear-gradient(135deg, #FFBE00 0%, #FF8D00 100%)',
    default: 'linear-gradient(135deg, #055BFD 0%, #07A2FF 100%)',
    darkblue: 'linear-gradient(135deg, #000000 0%, #FF8D00 100%)',
};

export default gradients;
